import {
  o
} from "./chunk.4JTBA2KG.js";

// src/styles/typography-types.styles.ts
function generateTypographyStyles(type) {
  return o(` font-size: var(--${type}-font-size); line-height: var(--${type}-line-height); letter-spacing: var(--${type}-letter-spacing); font-weight: var(--${type}-font-weight); `);
}
var headingXLarge = generateTypographyStyles("heading-x-large");
var headingLarge = generateTypographyStyles("heading-large");
var headingMedium = generateTypographyStyles("heading-medium");
var headingSmall = generateTypographyStyles("heading-small");
var headingXSmall = generateTypographyStyles("heading-x-small");
var headingXXSmall = generateTypographyStyles("heading-xx-small");
var headingXXXSmall = generateTypographyStyles("heading-xxx-small");
var labelLarge = generateTypographyStyles("label-large");
var labelMedium = generateTypographyStyles("label-medium");
var labelSmall = generateTypographyStyles("label-small");
var labelXSmall = generateTypographyStyles("label-x-small");
var labelXXSmall = generateTypographyStyles("label-xx-small");
var paragraphLarge = generateTypographyStyles("paragraph-large");
var paragraphMedium = generateTypographyStyles("paragraph-medium");
var paragraphSmall = generateTypographyStyles("paragraph-small");
var paragraphXSmall = generateTypographyStyles("paragraph-x-small");
var displayLarge = generateTypographyStyles("display-large");
var displayMedium = generateTypographyStyles("display-medium");
var displaySmall = generateTypographyStyles("display-small");
var tableHeader = generateTypographyStyles("table-header");
var tableData = generateTypographyStyles("table-data");

export {
  headingXLarge,
  headingLarge,
  headingMedium,
  headingSmall,
  headingXSmall,
  headingXXSmall,
  headingXXXSmall,
  labelLarge,
  labelMedium,
  labelSmall,
  labelXSmall,
  labelXXSmall,
  paragraphLarge,
  paragraphMedium,
  paragraphSmall,
  paragraphXSmall,
  displayLarge,
  displayMedium,
  displaySmall,
  tableHeader,
  tableData
};
